(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tress-color-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tress-color-browser')) {
  customElements.define('tress-color-browser', class extends HTMLElement {
    static memory = new Map();
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.search = this.querySelector('[data-tress-color-search]');
      this.buttons = [...this.querySelectorAll('[data-color-family]')];
      this.choices = [...this.querySelectorAll('[data-color-name]')];
      this.output = this.querySelector('[data-color-results]');
      this.empty = this.querySelector('[data-color-empty]');
      if (!this.search || !this.output) return;
      this.state = { ...(this.constructor.memory.get(this.dataset.colorKey) || { query: '', family: 'all' }) };
      this.search.value = this.state.query;
      this.buttons.forEach(button => {
        button.hidden = button.dataset.colorFamily !== 'all' && !this.choices.some(choice => this.inFamily(choice.dataset.colorName, button.dataset.colorFamily));
      });
      if (this.buttons.find(button => button.dataset.colorFamily === this.state.family)?.hidden) this.state.family = 'all';
      this.addEventListener('input', event => {
        if (event.target !== this.search) return;
        this.state.query = this.search.value;
        this.filter();
      });
      this.addEventListener('change', event => {
        if (event.target === this.search) event.stopPropagation();
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-color-family], [data-color-reset]');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-color-reset')) {
          this.state = { query: '', family: 'all' };
          this.search.value = '';
          this.search.focus();
        } else {
          this.state.family = button.dataset.colorFamily;
        }
        this.filter();
      });
      this.filter();
    }
    normalize(value) {
      return value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
    }
    inFamily(value, family) {
      const name = this.normalize(value);
      const multi = /balayage|root|gestrahnt|ombre|highlight|\//.test(name);
      if (family === 'all') return true;
      if (family === 'multi') return multi;
      if (multi) return false;
      const matches = { blonde: /blond/, brown: /braun|brown|espresso|mokka|chocolate/, black: /schwarz|black/, red: /rot|red|kupfer|copper|burgund|mahagoni/, grey: /grau|grey|gray|silver|weiss|white/ };
      return matches[family]?.test(name) || false;
    }
    filter() {
      const query = this.normalize(this.state.query.trim());
      let shown = 0;
      this.choices.forEach(choice => {
        const name = choice.dataset.colorName;
        const match = this.inFamily(name, this.state.family) && this.normalize(name).includes(query);
        choice.hidden = !match;
        if (match) shown++;
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colorFamily === this.state.family)));
      this.output.textContent = this.output.dataset.format.replace('__shown__', shown).replace('__total__', this.choices.length);
      this.empty.hidden = shown !== 0;
      this.constructor.memory.set(this.dataset.colorKey, { ...this.state });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
